import PropTypes from 'prop-types';

import { orderRow } from '../../utils/proptypes';
import OrderRow from '../OrderRow';

export default function OrderTable({ rows }) {
  const items = rows.map((row, index) => {
    const isPlan = !!row.included;
    return (
      <OrderRow
        className="order-row"
        row={row}
        isPlan={isPlan}
        key={`${row.orderTaskUuid || row.orderItemUuid}-${index}`}
      />
    );
  });
  return (
    <tbody>
      {items}
    </tbody>
  );
}

OrderTable.propTypes = {
  rows: PropTypes.arrayOf(orderRow).isRequired
};
